import { CompanyAPI } from '@api/buser-http-client';

const generateArtesp = (params) => CompanyAPI.generateArtesp(params)
  .then((data) => data)
  .catch((error) => Promise.reject(error.response?.data || error.response));

export { generateArtesp };
